import API from "../../../../../Services/API";
import { ENDPOINTS } from "utils/endpoints";
import {
  FETCH_EXTENDED_PREVIEW_BEGIN,
  FETCH_EXTENDED_PREVIEW_SUCCESS,
  FETCH_EXTENDED_PREVIEW_FAILURE
} from "./types";
import { GENERIC_ERROR_MESSAGE } from "../../DownloadAndDelete/actions/types";

export const fetchExtendedPreview = cardId => async dispatch => {
  dispatch({ type: FETCH_EXTENDED_PREVIEW_BEGIN });

  const url = `${ENDPOINTS.USER_EXTENDED_PREVIEWS}/${cardId}`;

  try {
    const response = await API.post(url);

    if (response && response.data && response.data.subcategoryData) {
      dispatch({
        type: FETCH_EXTENDED_PREVIEW_SUCCESS,
        payload: response.data.subcategoryData
      });
    } else {
      dispatch({ type: FETCH_EXTENDED_PREVIEW_FAILURE, payload: GENERIC_ERROR_MESSAGE });
    }
  } catch (error) {
    dispatch({ type: FETCH_EXTENDED_PREVIEW_FAILURE, payload: error.response.description });
  }
};
